import React from "react";
import { Link } from "react-router-dom";
import { Radio } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const KIND_LABEL = { auction: "Auction", need: "Need", match: "Match", offer: "Offer", lead: "Lead", rate: "Rate" };
const price = (r) => {
  const v = r.bid ?? r.ask ?? r.price;
  return typeof v === "number" && v > 0 ? `${r.currency === "INR" || !r.currency ? "₹" : r.currency + " "}${v.toLocaleString("en-IN")}` : null;
};

// Live World rows from /search/universal (bucket "live") — same result_id contract as the Live World page.
export function LiveResults({ rows, q, full = false }) {
  const { t } = useI18n();
  if (!rows.length && !full) return null;
  const shown = full ? rows : rows.slice(0, 6);
  return (
    <div className="mb-4" data-testid={full ? "uni-live-list" : "uni-live-rail"}>
      <div className="text-[11px] uppercase tracking-widest font-bold text-stone-500 mb-2 flex items-center gap-1">
        <Radio size={12} className="text-emerald-600" /> {t("live.title", "Live World")}
        <Link to={`/live-world${q ? `?q=${encodeURIComponent(q)}` : ""}`} className="ms-auto normal-case tracking-normal text-emerald-700 underline" data-testid="uni-live-open">{t("live.open", "Open Live World")} ↗</Link>
      </div>
      {shown.length === 0 ? <div className="text-sm text-stone-500" data-testid="uni-live-empty">{t("live.empty", "No live needs, offers, auctions or rates match this search nearby.")}</div> : (
        <div className={full ? "grid grid-cols-1 md:grid-cols-2 gap-2" : "flex gap-2 flex-wrap"}>
          {shown.map((r) => (
            <Link key={r.result_id || r.id} to={`/live-world?q=${encodeURIComponent(r.title || q || "")}`} data-testid={`uni-live-${r.id}`}
                  className="text-xs bg-white border border-stone-200 hover:border-emerald-400 rounded-2xl px-3 py-2 inline-flex items-center gap-2 max-w-full min-w-0 transition-colors">
              <span className="font-black text-emerald-700 uppercase text-[10px]">{t(`live.kind.${r.kind}`, KIND_LABEL[r.kind] || r.kind)}</span>
              <span className="font-bold text-stone-800 truncate min-w-0 max-w-[220px]">{r.title}</span>
              {price(r) && <span className="text-stone-600 shrink-0">{price(r)}</span>}
              {r.distance_km != null && <span className="text-stone-400 shrink-0">· {r.distance_km} km</span>}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
